import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { getInitialTheme, applyTheme } from './theme/useTheme';
import { i18nReady } from './language/i18n';

applyTheme(getInitialTheme());

const root = ReactDOM.createRoot(document.getElementById('root'));
i18nReady.finally(() => {
  root.render(
    // <React.StrictMode>
      <App />
    // </React.StrictMode>
  );
});